<script setup lang="ts">
import {
  WidgetHomePageHeroBanners,
  WidgetHomePageCtaExchangeRates,
  WidgetHomePageServices,
  WidgetHomePageNews,
  WidgetHomePageOrganizationRating
} from '~/components/widget/home-page'
import { WidgetFrequentlySearched } from '~/components/widget/frequently-searched'
import { WidgetHomePageBestOffers } from '~/components/widget/best-offers'
import { WidgetReviveAd } from '~/components/widget/revive-ad'

const {
  public: { siteUrl, assetUrl }
} = useRuntimeConfig()
useHead({
  link: [
    { rel: 'alternate', type: 'application/rss+xml', href: `${siteUrl}/rss` },
    {
      rel: 'preload',
      as: 'image',
      href: `${assetUrl}/images/photostock/credits.avif`,
      fetchpriority: 'high'
    }
  ]
})

const stickyRatesTriggerEl = inject<Ref<HTMLElement | null>>('stickyRatesTriggerEl')
const localRef = ref<HTMLElement | null>(null)

onMounted(() => {
  if (stickyRatesTriggerEl && localRef.value) {
    stickyRatesTriggerEl.value = localRef.value
  }
})
</script>

<template>
  <main class="bg-white">
    <Container class="flex flex-col gap-7 py-4 md:gap-10 md:py-10">
      <WidgetHomePageHeroBanners />
      <div class="grid gap-5 lg:grid-cols-2">
        <!-- The banner is injected after hydration; the reserved height of the promo
             creative keeps the content below from jumping (CLS, #296) -->
        <WidgetReviveAd
          zoneid="38"
          class="min-h-[98px] overflow-hidden rounded-lg md:min-h-[78px] lg:min-h-0"
        />
        <div ref="localRef">
          <WidgetHomePageCtaExchangeRates class="h-full" />
        </div>
      </div>
      <section>
        <WidgetHomePageServices />
      </section>
    </Container>
    <section class="bg-gray-100 py-7">
      <Container>
        <WidgetHomePageBestOffers />
      </Container>
    </section>
    <section class="bg-white py-7 md:py-10">
      <Container>
        <WidgetHomePageOrganizationRating />
      </Container>
    </section>
    <section class="overflow-hidden bg-gray-100 py-7">
      <Container>
        <WidgetHomePageNews />
      </Container>
    </section>
    <WidgetFrequentlySearched />
  </main>
</template>
